import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { FORCAS_META } from './forcas-meta.js';

export type EvolutionPoint = {
  diagnostico_id: string;
  title: string | null;
  created_at: string;
  media: number;
  forcas: number[];
  respostas_count: number;
};

type Props = { points: EvolutionPoint[] };

export function EvolutionChart({ points }: Props) {
  if (points.length < 2) return null;

  const chartData = [...points].reverse().map((e, i) => {
    const label =
      e.title?.trim() ||
      new Date(e.created_at).toLocaleDateString('pt-BR', { month: 'short', year: '2-digit' });
    const row: Record<string, string | number> = { label, idx: i + 1 };
    FORCAS_META.forEach((f, fi) => {
      row[f.nome] = e.forcas[fi] ?? 0;
    });
    return row;
  });

  return (
    <div className="mb-8 h-72 w-full max-w-3xl border border-ha-border bg-ha-card p-4">
      <h2 className="mb-2 text-xs font-bold uppercase text-ha-muted">Evolução por força</h2>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData}>
          <CartesianGrid stroke="var(--border)" />
          <XAxis dataKey="label" stroke="var(--text3)" fontSize={10} />
          <YAxis domain={[0, 10]} stroke="var(--text3)" fontSize={10} />
          <Tooltip
            contentStyle={{ background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', fontSize: 11 }}
            formatter={(v: number) => v.toFixed(1)}
          />
          <Legend wrapperStyle={{ fontSize: 10 }} />
          {FORCAS_META.map((f) => (
            <Line
              key={f.nome}
              type="monotone"
              dataKey={f.nome}
              stroke={f.hex}
              strokeWidth={2}
              dot={{ fill: f.hex, r: 3 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
